module.exports = __webpack_public_path__ + "static/media/wolters-kluwer.a971e466.png";